// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file user_management/user_management.proto (package user_management, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message user_management.GetMembersRequest
 */
export type GetMembersRequest = {
/**
 * Required: Group name to fetch members from (e.g., "hadc_env_user", "hadc_env_admin", "hadc_env_qa", or any custom group)
 *
 * @generated from field: string group_name = 1;
 */
groupName?: string;
}
;
/**
 * @generated from message user_management.GetMembersResponse
 */
export type GetMembersResponse = {
/**
 * @generated from field: repeated user_management.UserProfile members = 1;
 */
members?: UserProfile[];
/**
 * @generated from field: string group_name = 2;
 */
groupName?: string;
}
;
/**
 * @generated from message user_management.UserProfile
 */
export type UserProfile = {
/**
 * @generated from field: string id = 1;
 */
id?: string;
/**
 * @generated from field: string email = 2;
 */
email?: string;
/**
 * @generated from field: string first_name = 3;
 */
firstName?: string;
/**
 * @generated from field: string last_name = 4;
 */
lastName?: string;
/**
 * @generated from field: string login = 5;
 */
login?: string;
/**
 * @generated from field: string status = 6;
 */
status?: string;
/**
 * @generated from field: string profile_source = 7;
 */
profileSource?: string;
}
;
/**
 * @generated from message user_management.MemberInfo
 */
export type MemberInfo = {
/**
 * @generated from field: string first_name = 1;
 */
firstName?: string;
/**
 * @generated from field: string last_name = 2;
 */
lastName?: string;
/**
 * @generated from field: string email = 3;
 */
email?: string;
}
;
/**
 * @generated from message user_management.AddMemberRequest
 */
export type AddMemberRequest = {
/**
 * @generated from field: repeated user_management.MemberInfo members = 1;
 */
members?: MemberInfo[];
/**
 * Required: Group names to add users to (e.g., ["hadc_env_user", "hadc_env_qa"])
 *
 * @generated from field: repeated string group_names = 2;
 */
groupNames?: string[];
/**
 * @generated from field: string modified_by = 3;
 */
modifiedBy?: string;
/**
 * @generated from field: double timestamp = 4;
 */
timestamp?: number;
/**
 * @generated from field: user_management.UserContext user_context = 5;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message user_management.AddMemberResponse
 */
export type AddMemberResponse = {
/**
 * @generated from field: string status_update = 1;
 */
statusUpdate?: string;
}
;
/**
 * @generated from message user_management.RemoveMemberRequest
 */
export type RemoveMemberRequest = {
/**
 * @generated from field: repeated user_management.MemberInfo members = 1;
 */
members?: MemberInfo[];
/**
 * Required: Group names to remove users from (e.g., ["hadc_env_user", "hadc_env_qa"])
 *
 * @generated from field: repeated string group_names = 2;
 */
groupNames?: string[];
/**
 * @generated from field: string modified_by = 3;
 */
modifiedBy?: string;
/**
 * @generated from field: double timestamp = 4;
 */
timestamp?: number;
/**
 * @generated from field: user_management.UserContext user_context = 5;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message user_management.RemoveMemberResponse
 */
export type RemoveMemberResponse = {
/**
 * @generated from field: string status_update = 1;
 */
statusUpdate?: string;
}
;
/**
 * @generated from message user_management.ResendActivationEmailsRequest
 */
export type ResendActivationEmailsRequest = {
/**
 * @generated from field: repeated string userEmails = 1;
 */
userEmails?: string[];
/**
 * @generated from field: user_management.UserContext user_context = 2;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message user_management.ResendActivationEmailsResponse
 */
export type ResendActivationEmailsResponse = {
/**
 * @generated from field: bool isSuccess = 1;
 */
isSuccess?: boolean;
/**
 * @generated from field: repeated string failedEmails = 2;
 */
failedEmails?: string[];
}
;
/**
 * @generated from message user_management.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc user_management.UserManagementService.GetMembers
 */
export const UserManagementService_GetMembers = new RPC<GetMembersRequest,GetMembersResponse>("GET", "/getMembers");
/**
 * @generated from rpc user_management.UserManagementService.AddMembers
 */
export const UserManagementService_AddMembers = new RPC<AddMemberRequest,AddMemberResponse>("POST", "/addMembers");
/**
 * @generated from rpc user_management.UserManagementService.RemoveMembers
 */
export const UserManagementService_RemoveMembers = new RPC<RemoveMemberRequest,RemoveMemberResponse>("POST", "/removeMembers");
/**
 * @generated from rpc user_management.UserManagementService.ResendActivationEmails
 */
export const UserManagementService_ResendActivationEmails = new RPC<ResendActivationEmailsRequest,ResendActivationEmailsResponse>("POST", "/resendActivationEmails");
